<template>
  <div class="card-sty">
    <v-card
      @click="goingIntoCustomer"
      style="
  background-color: #0d47a1; ; 
  border-radius: 15px; 
  border-bottom: 15px solid #0d47a1;
  "
    >
      <!-- <div align="center" class="white--text">
         <h2>{{gag.component_name}}</h2>

    </div> -->
      <v-card
        align="center"
        class="item1 card-center border border-primary"
        style="  border-left: 20px solid #0d47a1;
      border-right: 20px solid #0d47a1;  solid #0d47a1;  "
      >
        <v-card-title> </v-card-title>
        <v-card-text style="margin-bottom: -20px;">
          <div
            class="transition-swing text-h7 font-weight-bold text-center"
            style="margin-top: -20px;"
          >
            {{ gag.component_name }}
          </div>
          <apexchart
            type="radialBar"
            :options="chartOptions"
            :series="gag.series"
          >
          </apexchart>
          <h6
            v-bind:class="{
              minClass: gag.isEnergy == 'true',
              minClass1: gag.isEnergy == 'false',
            }"
          >
            {{ gag.minValue }}
          </h6>
          <h6
            v-bind:class="{
              maxClass: gag.isEnergy == 'true',
              maxClass1: gag.isEnergy == 'false',
            }"
          >
            {{ gag.maxValue }}
          </h6>
          <h6
            style="font-size: small; 
        text-align: center"
          >
            {{ gag.originalValue }}
          </h6>

          <h6 style="font-size: small; text-align: center;">
            {{ gag.timestamp }}
          </h6>
        </v-card-text>
      </v-card>
      <div v-if="gag.machine_state">
        <v-btn
          class="mx-0 white--text"
          fab
          x-small
          color="green"
          :style="{
            left: '50%',
            transform: 'translateX(-50%)',
            marginBottom: '5px',
            marginTop: '5px',
          }"
          >ON
        </v-btn>
      </div>
      <div v-if="!gag.machine_state">
        <v-btn
          class="mx-0 white--text"
          fab
          x-small
          color="red"
          :style="{
            left: '50%',
            transform: 'translateX(-50%)',
            marginBottom: '5px',
            marginTop: '5px',
          }"
        >
          OFF
        </v-btn>
      </div>
    </v-card>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import router from "../router";

export default {
  name: "super_admin_guage",
  props: ["gag"],
  components: {
    apexchart: VueApexCharts,
  },

  data: function() {
    return {
      //message: 'time to update',
      //unit: 'unit',
      //component_name: "name",
      //series: [76],
      isEnergy: "true",
      chartOptions: {
        chart: {
          type: "radialBar",
          offsetY: -20,
          sparkline: {
            enabled: true,
          },
        },
        // title: {
        //   text: this.gag.component_name,
        //   align: "center",
        //   style: {
        //     color: "#484848",
        //     // fontFamily: "EMPrint",
        //     marginTop:"-5px;",
        //     fontSize: "18px",
        //     fontWeight: "bold",
        //   },
        // },
        plotOptions: {
          radialBar: {
            startAngle: -90,
            endAngle: 90,
            //                                  hollow: {
            //                  margin: 0,
            //                  size: '70%',
            //                background: '#fff',
            //              image: undefined,
            //            imageOffsetX: 0,
            //          imageOffsetY: 0,
            //        position: 'front',
            //      dropShadow: {
            //        enabled: true,
            //        top: 3,
            //        left: 0,
            //        blur: 4,
            //        opacity: 0.24
            //     }
            //   },
            track: {
              background: "#e7e7e7",
              strokeWidth: "90%",
              margin: 5, // margin is in pixels
              dropShadow: {
                enabled: true,
                top: 2,
                left: 0,
                color: "#999",
                opacity: 1,
                blur: 2,
              },
            },
            dataLabels: {
              textAnchor: "middle",
              name: {
                // show: false,
                name: {
                  fontSize: "18px",
                  offsetY: -50,
                  color: "#222222",
                },
              },
              value: {
                offsetY: -2,
                fontSize: "0px",
                formatter: function(val) {
                  return val + "%";
                },
              },
            },
          },
        },
        //grid: {
        //padding: {
        //top: -10,
        //},
        //},
        fill: {
          // type: "gradient",
          colors: ["#002080"],
          //       gradient: {
          //       shade: "dark",
          //     shadeIntensity: 0.4,
          //   inverseColors: false,
          // opacityFrom: 1,
          //opacityTo: 1,
          //stops: [0, 50, 53, 91],
          // },
        },
        // stroke: {
        //   dashArray: 4
        //    },
        labels: [""],
      },
    };
  },
  methods: {
    goingIntoCustomer() {
      console.log("checkign id", this.gag.customer_id);
      sessionStorage.removeItem("route_first_option");

      sessionStorage.setItem("route_first_option", "/");
      sessionStorage.setItem("super_to_user_org_id", `${this.gag.customer_id}`);

      router.push("/");

      //  this.$root.$emit('value_of_checkbox', gag.customer_id);
    },
  },
};
</script>

<style scoped>
@import "../assets/fonts/style.css";

#gauge-card {
  /* border-style: solid ;
  border-radius: 15px;
    border-color: #a7a7a7; */
}
.item2 {
  font-family: "EMPrint";
  font-size: 16px;
  font-weight: bold;
}
.minClass {
  font-size: small;
  font-weight: bolder;
  text-align: center;
  /* top bottom left right */
  margin: -20px 50px -5px -30px;
}
.minClass1 {
  font-size: small;
  font-weight: bolder;
  text-align: center;
  /* top bottom left right */

  margin: -20px 140px -5px -30px;
}
.maxClass {
  font-size: small;
  font-weight: bolder;
  text-align: center;
  /* top bottom left right */

  margin: -22px -200px 0px -140px;
}
.maxClass1 {
  font-size: small;
  font-weight: bolder;
  text-align: center;
  /* top bottom left right */

  margin: -22px -300px 0px -140px;
}
@media screen and (max-width: 600px) {
  .card-sty {
    width: 100%;
  }
}
</style>
